import React, { useState, useEffect } from "react";
import { sendUnitData } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";
import { Modal } from "../../../components/ui";

const initialState = {
    unitID: 0,
    unitName: "",
    unitDescription: "",
};

const inputClass =
    "w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500";
const labelClass = "block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-1";

export function UnitForm({ isOpen, onClose, units, selectedUnit, setUnits }) {
    const [item, setItem] = useState(initialState);

    const saveUnit = async (data) => {
        try {
            const response = await sendUnitData(data);
            return response;
        } catch (error) {
            throw error;
        }
    };

    function handleChange(e) {
        setItem({ ...item, [e.target.name]: e.target.value });
    }

    const updateUnits = units.map((unit) => {
        if (unit.unitID === item.unitID) {
            const newItem = Object.assign({}, unit);
            newItem.unitName = item.unitName;
            newItem.unitDescription = item.unitDescription;
            return newItem;
        }
        return unit;
    });

    const handleSubmit = (e) => {
        e.preventDefault();

        if (item.unitID == 0) {
            saveUnit(item).then(async (res) => {
                item.unitID = res.unitID;
                setItem(item);
                setUnits((prevPlanes) => [...prevPlanes, item]);
                toast.success("Unidad registrada con exito!");
            });
        } else {
            setUnits(updateUnits);
            saveUnit(item);
            toast.success("Unidad actualizada con exito!");
        }
        onClose();
    };

    useEffect(() => {
        const unitFound = units.find(
            (item2) => item2.unitID === selectedUnit.unitID
        );
        if (unitFound) {
            setItem({
                unitID: unitFound.unitID,
                unitName: unitFound.unitName,
                unitDescription: unitFound.unitDescription,
            });
        } else {
            setItem(initialState);
        }
    }, [selectedUnit, units]);

    const modalTitle = (
        <>
            <i
                className={`fas ${item.unitID ? "fa-edit" : "fa-plus-circle"} text-cyan-600 dark:text-cyan-400`}
                aria-hidden="true"
            />
            <span>{item.unitID ? "Editar Unidad" : "Nueva Unidad"}</span>
        </>
    );

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={modalTitle} size="sm">
            <input type="hidden" value={item.unitID} />

            <div className="space-y-4 -mt-2">
                <div>
                    <label className={labelClass}>
                        <i className="fas fa-cube mr-1" aria-hidden="true" />
                        Nombre (Abreviatura){" "}
                        <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        className={inputClass}
                        placeholder="Ej: KG, UND, LT, MT..."
                        name="unitName"
                        maxLength={5}
                        value={item.unitName}
                        onChange={handleChange}
                        autoFocus
                    />
                    <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                        Máximo 5 caracteres
                    </p>
                </div>

                <div>
                    <label className={labelClass}>
                        <i className="fas fa-align-left mr-1" aria-hidden="true" />
                        Descripción <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        className={inputClass}
                        placeholder="Ej: Kilogramo, Unidad, Litro, Metro..."
                        name="unitDescription"
                        maxLength={100}
                        value={item.unitDescription}
                        onChange={handleChange}
                    />
                    <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                        Máximo 100 caracteres
                    </p>
                </div>
            </div>

            <div className="mt-6 flex flex-wrap justify-end gap-2 border-t border-gray-200 pt-4 dark:border-gray-700">
                <button
                    type="button"
                    onClick={onClose}
                    className="inline-flex items-center rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:text-gray-300 dark:hover:bg-gray-700"
                >
                    <i className="fas fa-times mr-1" aria-hidden="true" />
                    Cancelar
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="inline-flex items-center rounded-lg bg-green-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-green-700"
                >
                    <i
                        className={`fas ${item.unitID ? "fa-save" : "fa-plus"} mr-1`}
                        aria-hidden="true"
                    />
                    {item.unitID ? "Guardar Cambios" : "Registrar Unidad"}
                </button>
            </div>
        </Modal>
    );
}
